module.exports = __webpack_public_path__ + "img/physics3.44a9df04.png";